var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 987363"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2114",
    x: 7,
    y: 6,
    width: 12,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3382 8.81143L24 12L21.3382 15.1886L21.7091 19.4057L17.7709 20.3429L15.7091 23.9886L12 22.32L8.29091 24L6.22909 20.3543L2.29091 19.4171L2.66182 15.1886L0 12L2.66182 8.8L2.29091 4.57143L6.22909 3.64571L8.29091 0L12 1.66857L15.7091 0L17.7709 3.65714L21.7091 4.59429L21.3382 8.81143ZM8 9.75C8 8.785 8.785 8 9.75 8C10.715 8 11.5 8.785 11.5 9.75C11.5 10.715 10.715 11.5 9.75 11.5C8.785 11.5 8 10.715 8 9.75ZM9 9.75C9 10.165 9.335 10.5 9.75 10.5C10.165 10.5 10.5 10.165 10.5 9.75C10.5 9.335 10.165 9 9.75 9C9.335 9 9 9.335 9 9.75ZM12.5 14.25C12.5 13.285 13.285 12.5 14.25 12.5C15.215 12.5 16 13.285 16 14.25C16 15.215 15.215 16 14.25 16C13.285 16 12.5 15.215 12.5 14.25ZM13.5 14.25C13.5 14.665 13.835 15 14.25 15C14.665 15 15 14.665 15 14.25C15 13.835 14.665 13.5 14.25 13.5C13.835 13.5 13.5 13.835 13.5 14.25ZM8 15.295L8.705 16L16 8.705L15.295 8L8 15.295Z",
    fill: "#234B9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.205470ecbcc2ac6fbc965f9858f86b25.svg";
export { ForwardRef as ReactComponent };